import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QueryKeys } from '../query-keys';

import { quantaApi } from './quantaApi';
import { RegisterUser } from './useQuantaLogin';
import { QuantaHeaders } from './auth';

export interface Stats {
  points: number;
  missions_completed: number;
  tasks_completed: number;
}

export interface Referral {
  referred: boolean;
  referrer: string | null;
  points: number;
}

export interface QuantaRegisterResponse {
  data: {
    user: RegisterUser;
    stats: Stats;
    referral: Referral;
  };
}

interface QuantaRegisterParams {
  headers: QuantaHeaders;
  referralCode: string;
}

export const useQuantaRegister = (): UseMutationResult<QuantaRegisterResponse, AxiosError<{ error: string }>, QuantaRegisterParams> => {
  return useMutation<QuantaRegisterResponse, AxiosError<{ error: string }>, QuantaRegisterParams>({
    mutationKey: [QueryKeys.quantaRegister],
    mutationFn: async ({ headers, referralCode }: QuantaRegisterParams) => {
      const path = referralCode ? `/registration?referral=${referralCode}` : '/registration';
      const response = await quantaApi.post(path, undefined, {
        headers,
      });

      return response.data;
    },
    onError: (e: any) => {
      if (e.status === 409 && e.response.data?.error === 'User with this wallet or public key already exists') {
        // This is OK.
      } else {
        console.log(e);
      }
    },
  });
};
